<template lang="pug">
    el-carousel(height="240px" type="card")
        el-carousel-item.carousel(v-for="item in items" :key="item.value")
            .recommend-item(@click="clickHandler(item)")
                p.title(v-if="item.type == 'aoi'")
                    i.icon.icon-aoi
                    | {{item.title}}
                p.title(v-else)
                    i.icon.icon-pdf
                    | 《{{item.title}}》

                p(v-if="item.reason") 推荐理由：『{{item.reason}}』
                p.link-description(v-if="item.type == 'aoi'") 点击前往购买 >
                p.link-description(v-else) 下载查看 >

</template>

<script>
import storeMixin from '../store/mixin';
import DownloadDisclosure from '../utils/download-disclosure';

export default {
    name: 'Recommend',
    mixins: [storeMixin],
    data() {
        return {
            items: null,
        };
    },
    created() {
        this.getList();
    },
    computed: {
        carouselSize() {
            if (this.items) return Math.ceil(this.items.length / 4);
        },
    },
    methods: {
        async getList() {
            const { data } = await this.REQUEST({
                url: 'v2/recommend/list',
            });
            this.items = data.items;
        },
        clickHandler(item) {
            if (item.type == 'disclosure') {
                DownloadDisclosure(item.target_info);
            } else if (item.type == 'aoi') {
                const info = JSON.parse(item.target_info);
                window.sessionStorage['aoi_geometry_geojson'] =
                    info['geometry_geojson'];
                this.$router.push('/aoi');
            }
        },
    },
};
</script>

<style lang="stylus" scoped>
// .recommend-list
//     display flex
//     flex-wrap wrap
.recommend-item
    color #6f7284
    font-size 14px
    cursor pointer
    text-align center
    padding 20px
    height 240px
    background #9ca8bf

.title
    color #246cf9
    font-size 18px
    margin-bottom 20px
    white-space nowrap
    overflow hidden
    text-overflow ellipsis
.icon
    width 16px
    height 16px
    display inline-block
    margin-right 5px
    margin-bottom -2px
.icon-aoi
    background-image url('../imgs/icon-aoi.png')

.icon-pdf
    background-image url('../imgs/icon-pdf.png')
.link-description
    margin-top 10px
    text-decoration underline
</style>
